
import { Viewer } from "components/auth/types";

export type List = {
  id: string;
  name: string;
  property?: {
    isDraft?: boolean | null;
  } | null;
};

const noDeniedOrMovedIn = (list: List) => !list.name.match(/move|denial/i);
const onlyWithViewerAccess =
  (viewer:Viewer, list: List) =>
    viewer.lists?.some(vl => vl.id === list.id) ?? false;

const sortAndFilterLists = (viewer:Viewer, lists: List[]):List[] =>
  lists
    .filter(noDeniedOrMovedIn)
    .filter((list) => onlyWithViewerAccess(viewer, list))
    .sort((a, b) => (a.name > b.name ? 1 : -1));

export { sortAndFilterLists };
